import React, { useEffect, useState } from "react";
import WireLineJioFiberView from "../../views/wireLineJioFiber";
import DashboardFilterForSmbAndFiber from "../../components/dashboardFilterForSmbAndFiber/index";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchShowAlertEd1,
  fetchWirelineAch,
  fetchWirelinePlanCount,
  fetchWirelinePlanCsv,
  hideAlertEd1,
  resetEd1,
  toggleDateAlert,
  toggleErrorAlert,
} from "../../redux/actions/ed1AndEd2";
import { filterNames } from "../../utils/constants";
import Spinner from "../../components/presentationals/Spinner";
import CustomLandingBody from "../../components/customLandingBody";
import {
  triggerIsDashboardAccessible,
  setSelectedData,
  triggerDashboardAudit,
} from "../../redux/actions";
import {
  triggerShowHeader,
  unsetPayoutDashboard,
} from "../../redux/actions/action";
import { ExportToCsv } from "export-to-csv";
import { csvFilter } from "../../utils/common/csvMappings/ed1AndEd2Csv";
import config from "../../utils/config";
import { camelize, isEmptyObject } from "../../utils/common";

const WireLineJioFiber = () => {
  const dispatch = useDispatch();
  const {
    getAllAPI,
    tilesData,
    filterValue,
    headerSelectedDateFrom,
    headerSelectedDateTo,
  } = useSelector((state) => state.homeReducer);
  const { dashboardAccessibility } = useSelector(
    (state) => state?.dashboardAccessibilityReducer
  );

  const { wirelineAch, wirelinePlanCount, ed1FilterObj, selectedData } =
    useSelector((state) => state.Ed1AndEd2Reducer);

  const [showAlert, setShowAlert] = useState(null);
  const dashboardName = "WireLine JioFiber";

  let ed1Modules = getAllAPI?.data?.content?.filter(
    (row) => row.moduleName.toLowerCase() === filterNames.ed1.toLowerCase()
  )[0];

  let ed1Tiles = ed1Modules?.modSecMasterTxDtos?.filter((row) =>
    row.sectionName.toLowerCase().includes(filterNames.ed1)
  )?.[0]?.secTilesMasterTxDtos;

  const changeHandler = (type, value) => {
    if (type === "Partner Name") {
      dispatch(
        setSelectedData({
          ...selectedData,
          [type]: value,
        })
      );
    } else if (type === "State") {
      dispatch(
        setSelectedData({
          ...selectedData,
          [type]: value,
          "Partner Name": "",
        })
      );
    } else {
      dispatch(
        setSelectedData({
          [type]: value,
          State: "",
          "Partner Name": "",
        })
      );
    }
  };

  const runButtonClickHandler = () => {
    dispatch(resetEd1());
    fetchWirelineAchApi();
    fetchWirelinePlanCountApi();
  };

  const fetchWirelineAchApi = () => {
    const obj = {
      headers: {
        url: ed1Tiles?.filter(
          (row) => row?.tileName === filterNames.performance
        )[0].tileEndPointUrl,
      },
      params: {
        fromDate: headerSelectedDateFrom, //'10-AUG-2023',
        toDate: headerSelectedDateTo, //'12-AUG-2023',
        userId: !filterNames.partnerName.includes(filterValue.partnerName)
          ? selectedData["Partner Name"]?.partnerName?.split(" - ")[2]
          : filterValue.orgId,
      },
    };
    if (obj.headers.url) dispatch(fetchWirelineAch(obj));
  };

  const fetchWirelinePlanCountApi = () => {
    const obj = {
      headers: {
        url: ed1Tiles?.filter((row) => row?.tileName.includes("Plan"))[0]
          .tileEndPointUrl,
      },
      params: {
        fromDate: headerSelectedDateFrom, //'10-AUG-2023',
        toDate: headerSelectedDateTo, //'12-AUG-2023',
        userId: !filterNames.partnerName.includes(filterValue.partnerName)
          ? selectedData["Partner Name"]?.partnerName?.split(" - ")[2]
          : filterValue.orgId,
      },
    };
    dispatch(fetchWirelinePlanCount(obj));
  };

  const sendAudit = () => {
    const obj = {
      headers: {
        url: "/add-dashboard-audit",
      },
      params: {
        action: "download",
        dashboard: dashboardName,
        empId: filterValue?.orgId?.length
          ? filterValue?.orgId
          : filterValue?.agentId,
        empRole: filterValue.partnerName,
        remarks: "Dashboard Audit request",
        userType: filterValue?.site,
        viewName: ed1Tiles?.[0]?.tileName,
      },
    };
    triggerDashboardAudit(obj);
  };

  const fetchWirelinePlanCsvApi = () => {
    sendAudit();
    const dateDiff =
      (new Date(headerSelectedDateTo) - new Date(headerSelectedDateFrom)) /
      (1000 * 60 * 60 * 24);

    if (dateDiff > 6) {
      dispatch(toggleDateAlert());
      setTimeout(() => {
        dispatch(toggleDateAlert());
      }, 5000);
    } else {
      const obj = {
        headers: {
          url: ed1Tiles?.filter(
            (row) => row?.tileName === filterNames.performance
          )[0].csvEndPointUrl,
        },
        params: {
          fromDate: headerSelectedDateFrom, //'10-AUG-2023',
          toDate: headerSelectedDateTo, //'12-AUG-2023',
          userId: !filterNames.partnerName.includes(filterValue.partnerName)
            ? selectedData["Partner Name"]?.partnerName?.split(" - ")[2]
            : filterValue.orgId,
        },
      };
      let options = {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: false,
        title: "Data",
        useTextFile: false,
        filename: `Wireline_Plan`,
        useBom: true,
        useKeysAsHeaders: true,
        // headers: ['Column 1', 'Column 2', etc...] <-- Won't work with useKeysAsHeaders present!
      };

      let csvExporter = new ExportToCsv(options);
      dispatch(
        fetchWirelinePlanCsv(
          obj,
          (res) => {
            if (res?.content?.length) {
              let csvData;
              csvData = csvFilter(res.content);
              csvExporter.generateCsv(csvData);
            } else {
              dispatch(fetchShowAlertEd1());
              setTimeout(() => {
                dispatch(hideAlertEd1());
              }, 5000);
            }
          },
          (err) => {
            dispatch(toggleErrorAlert());
            setTimeout(() => {
              dispatch(toggleErrorAlert());
            }, 5000);
          }
        )
      );
    }
  };

  useEffect(() => {
    const unsetPayoutDashboardForCalender = () => {
      return dispatch(unsetPayoutDashboard());
    };
    unsetPayoutDashboardForCalender();
  }, []);

  useEffect(() => {
    // fetchWirelineAchApi();
    const showHeader = () => {
      return dispatch(triggerShowHeader(true));
    };

    //check if isTestingActive is true, then send api call for triggerIsDashboardAccessible
    let isTestingActive = tilesData?.data?.content?.filter(
      (obj) => obj.moduleName.toLowerCase() === filterNames.ed1
    )[0].isTestingActive;

    //if it is true, then check if this logged in user has access to this dashboard
    if (isTestingActive) {
      //to check if the response for this dashboard api call is already cached in redux
      let isExistingDashboard = dashboardAccessibility?.data?.filter(
        (currentDashboard) => currentDashboard.dashboard === dashboardName
      );

      //if dashboard accessibility is already cached and accessEnabled is false, means directly show alert without sending api call again
      if (
        isExistingDashboard.length > 0 &&
        !isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        // load dashboardcard home component and show alert
        return setShowAlert(true);
      }

      // if dashboard accessibility is cached and accessEnabled is true, do not send api call, do not show alert BUT SHOW DASHBOARD NORMALLY
      else if (
        isExistingDashboard.length > 0 &&
        isExistingDashboard[0]?.isDashboardAccessible?.accessEnabled
      ) {
        setShowAlert(false);
        showHeader();
      }

      //if dashboard accessibility is not cached already then send api call for this dashboard
      else {
        const data = {
          baseParameter: {
            name: dashboardName,
            userType: filterValue.site,
          },
          domainId:
            filterValue.orgId !== "" ? filterValue.orgId : filterValue?.agentId,
        };

        const obj = {
          headers: {
            "Content-Type": "application/json",
            url: "get-dashboard-user-role-mapping",
          },
          params: data,
          extraData: "get-dashboard-user-role-mapping",
        };

        return dispatch(
          triggerIsDashboardAccessible(obj, (res) => {
            //if the response shows access enabled as false, go to home page and show alert
            if (!res.content.accessEnabled) {
              setShowAlert(true);
            } else {
              setShowAlert(false);
              showHeader();
            }
          })
        );
      }
    }

    //if isTestingActive is false, it is open for all users
    else {
      setShowAlert(false);
      showHeader();
    }
  }, [getAllAPI]);

  useEffect(() => {
    console.log(filterValue.partnerName);
    if (
      (!filterNames.partnerName.includes(filterValue.partnerName) &&
        wirelineAch.data === null &&
        wirelinePlanCount.data === null &&
        !isEmptyObject(selectedData["Partner Name"])) ||
      (filterNames.partnerName.includes(filterValue.partnerName) &&
        wirelineAch.data === null &&
        wirelinePlanCount.data === null)
    ) {
      fetchWirelineAchApi();
      fetchWirelinePlanCountApi();
    }
  }, [
    ed1FilterObj,
    headerSelectedDateFrom,
    headerSelectedDateTo,
    getAllAPI,
    selectedData,
    // filterValue
  ]);

  useEffect(() => {
    if (filterValue.partnerName === "Region Head") {
      dispatch(
        setSelectedData({
          ...selectedData,
          Region: config.regionMaps[tilesData?.data?.extraData?.region],
          State:
            config.states[
              config.regionMaps[tilesData?.data?.extraData?.region]
            ][0],
        })
      );
    }
    if (filterValue.partnerName === "STATE HEAD") {
      dispatch(
        setSelectedData({
          ...selectedData,
          State: camelize(tilesData?.data?.extraData?.state),
        })
      );
    }
  }, [getAllAPI]);

  return showAlert === null ? (
    <Spinner />
  ) : showAlert ? (
    <CustomLandingBody showAlert={showAlert} dashboardName={dashboardName} />
  ) : (
    <div className="container-fluid">
      {!filterNames.partnerName.includes(filterValue.partnerName) && (
        <DashboardFilterForSmbAndFiber
          changeHandler={changeHandler}
          runButtonClickHandler={runButtonClickHandler}
          dashboardMenu={config.SmbAndFiberFilterFormConf}
          type={dashboardName}
        />
      )}
      <WireLineJioFiberView
        getAllAPI={getAllAPI}
        ed1Modules={ed1Modules}
        ed1Tiles={ed1Tiles}
        fetchWirelinePlanCsvApi={fetchWirelinePlanCsvApi}
      />
    </div>
  );
};

export default WireLineJioFiber;
